// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Menu: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="18" viewBox="0 0 32 18">
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M6,27.5 L38,27.5 L38,30.5 L6,30.5 Z M6,20.5 L38,20.5 L38,23.5 L6,23.5 Z M6,13.5 L38,13.5 L38,16.5 L6,16.5 Z"
                transform="translate(-6 -13)"
            />
        </svg>
    );
};

export default React.memo(Menu);
